
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { API } from "../../config/api";
import "../Styles/Concept.css";

export default function ConceptDetails() {

    const { folderName } = useParams();
    const navigate = useNavigate();

    const [images, setImages] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");
    const [title, setTitle] = useState("");

    // Lightbox
    const [selectedIndex, setSelectedIndex] = useState(null);

    useEffect(() => {
        fetchFolderImages();
    }, [folderName]);

    const fetchFolderImages = async () => {

        try {

            setLoading(true);
            setError("");

            const decodedFolder = decodeURIComponent(folderName);

            setTitle(decodedFolder);

            const url =
                `${API.BASE_URL}/Concepts.php?folder=${encodeURIComponent(decodedFolder)}`;

            console.log("Concept Details API:", url);

            const response = await fetch(url);

            const text = await response.text();

            console.log("Concept Details Response:", text);

            let result;

            try {

                result = JSON.parse(text);

            } catch (jsonError) {

                throw new Error(
                    `Invalid JSON response from Concepts.php. Response: ${text.substring(0, 300)}`
                );

            }

            if (!response.ok) {

                throw new Error(
                    result.message ||
                    `HTTP Error ${response.status}`
                );

            }

            if (!result.success) {

                throw new Error(
                    result.message ||
                    "Unable to load concept images."
                );

            }

            setImages(
                result.data?.images || []
            );

        } catch (error) {

            console.error(
                "ConceptDetails fetch error:",
                error
            );

            setError(
                error.message ||
                "Unable to load concept images."
            );

        } finally {

            setLoading(false);

        }
    };


    /* =========================================================
       OPEN IMAGE
    ========================================================= */

    const openImage = (index) => {

        setSelectedIndex(index);

        // Prevent background page scrolling
        document.body.style.overflow = "hidden";
    };


    /* =========================================================
       CLOSE IMAGE
    ========================================================= */

    const closeImage = () => {

        setSelectedIndex(null);

        // Restore page scrolling
        document.body.style.overflow = "";
    };


    /* =========================================================
       NEXT IMAGE
    ========================================================= */

    const nextImage = () => {

        if (!images.length) return;

        setSelectedIndex((current) => {

            if (current === null) return 0;

            return (current + 1) % images.length;

        });
    };


    /* =========================================================
       PREVIOUS IMAGE
    ========================================================= */

    const previousImage = () => {

        if (!images.length) return;

        setSelectedIndex((current) => {

            if (current === null) return 0;

            return (
                (current - 1 + images.length) %
                images.length
            );

        });
    };
/* =========================================================
   DOWNLOAD IMAGE
========================================================= */

const downloadImage = (image) => {

    if (!image) return;

    const url =
        `${API.BASE_URL}/DownloadConcept.php` +
        `?folder=${encodeURIComponent(title)}` +
        `&file=${encodeURIComponent(image.name)}`;

    window.location.href = url;
};

    /* =========================================================
       KEYBOARD CONTROLS
    ========================================================= */

    useEffect(() => {

        const handleKeyDown = (event) => {

            // Lightbox is not open
            if (selectedIndex === null) {
                return;
            }

            if (event.key === "Escape") {

                closeImage();

            } else if (event.key === "ArrowRight") {

                event.preventDefault();

                nextImage();

            } else if (event.key === "ArrowLeft") {

                event.preventDefault();

                previousImage();

            }

        };


        document.addEventListener(
            "keydown",
            handleKeyDown
        );


        return () => {

            document.removeEventListener(
                "keydown",
                handleKeyDown
            );

        };

    }, [selectedIndex, images.length]);


    /* =========================================================
       CLEANUP SCROLL
    ========================================================= */

    useEffect(() => {

        return () => {

            document.body.style.overflow = "";

        };

    }, []);


    /* =========================================================
       LOADING
    ========================================================= */

    if (loading) {

        return (
            <div className="concept-loading">
                Loading designs...
            </div>
        );

    }


    /* =========================================================
       ERROR
    ========================================================= */

    if (error) {

        return (
            <div className="concept-details-page">

                <div className="concept-error">

                    <strong>
                        Unable to load concept
                    </strong>

                    <div style={{ marginTop: "6px" }}>
                        {error}
                    </div>

                </div>

            </div>
        );

    }


    /* =========================================================
       PAGE
    ========================================================= */

    return (

        <div className="concept-details-page">

            <div className="concept-details-header">

                <button
                    type="button"
                    className="concept-back-btn"
                    onClick={() => navigate("/Concept")}
                >

                    <i className="bi bi-arrow-left"></i>

                    <span>
                        Back
                    </span>

                </button>


                <div>

                    <h2>
                        {title}
                    </h2>

                    <p>

                        {images.length}{" "}

                        {images.length === 1
                            ? "Design"
                            : "Designs"}

                    </p>

                </div>

            </div>


            {images.length === 0 ? (

                <div className="concept-empty">

                    No images found in this folder.

                </div>

            ) : (

                <div className="concept-images-grid">

                    {images.map((image, index) => (

                        <div
    className="concept-design-card"
    key={`${image.name}-${index}`}
    onClick={() => openImage(index)}
>

    <img
        src={image.url}
        alt={image.name}
        loading="lazy"
    />

    <button
        type="button"
        className="concept-image-download"
        onClick={(event) => {
            event.stopPropagation();
            downloadImage(image);
        }}
        title="Download image"
        aria-label="Download image"
    >
        <i className="bi bi-download"></i>
    </button>

</div>

                    ))}

                </div>

            )}


            {/* =================================================
                IMAGE LIGHTBOX
            ================================================= */}

            {selectedIndex !== null &&
                images[selectedIndex] && (

                    <div
                        className="concept-lightbox"
                        onClick={closeImage}
                    >

                        {/* CLOSE BUTTON */}

                        <button
                            type="button"
                            className="concept-lightbox-close"
                            onClick={(event) => {
                                event.stopPropagation();
                                closeImage();
                            }}
                            aria-label="Close"
                        >

                            <i className="bi bi-x-lg"></i>

                        </button>


                        {/* IMAGE COUNTER */}

                      

                        {/* PREVIOUS BUTTON */}

                        {images.length > 1 && (

                            <button
                                type="button"
                                className="concept-lightbox-prev"
                                onClick={(event) => {
                                    event.stopPropagation();
                                    previousImage();
                                }}
                                aria-label="Previous image"
                            >

                                <i className="bi bi-chevron-left"></i>

                            </button>

                        )}


                        {/* IMAGE */}

                       {/* IMAGE */}

<div
    className="concept-lightbox-image-wrapper"
    onClick={(event) => {
        event.stopPropagation();
    }}
>

    <img
        src={images[selectedIndex].url}
        alt={images[selectedIndex].name}
        className="concept-lightbox-image"
    />

</div>


{/* DOWNLOAD BUTTON */}

<button
    type="button"
    className="concept-lightbox-download"
    onClick={(event) => {
        event.stopPropagation();
        downloadImage(images[selectedIndex]);
    }}
    aria-label="Download image"
    title="Download image"
>

    <i className="bi bi-download"></i>

    <span>
        Download
    </span>

</button>


{/* NEXT BUTTON */}

{images.length > 1 && (

    <button
        type="button"
        className="concept-lightbox-next"
        onClick={(event) => {
            event.stopPropagation();
            nextImage();
        }}
        aria-label="Next image"
    >

        <i className="bi bi-chevron-right"></i>

    </button>

)}


                 
  <div className="concept-lightbox-counter">

                            {selectedIndex + 1}
                            {" / "}
                            {images.length}

                        </div>

                    </div>

                )}

        </div>

    );

}


